dmx.Attribute("html", "mounted", function (node, attr) {
  let _value = null;
  let _request = null;

  this.$watch(attr.value, value => {
    _value = value;
    if (!_request) {
      _request = requestAnimationFrame(() => {
        const html = _value != null ? String(_value) : "";
        node.innerHTML = html;
        _request = null;
      });
    }
  });
});
